export const educationData = [
    {
        id: 1,
        institution: 'Beni Swif University',
        course: 'Bachelor of Economics',
        startYear: '2015',
        endYear: '2019'
    },
    {
        id: 2,
        institution: 'Microverse online School',
        course: 'Full-stack Web development',
        startYear: '2022',
        endYear: '2023'
    },
]